module.exports = __webpack_public_path__ + "img/symptoms.49045359.png";